import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { ApiService } from '../services/api.service';
import { REST_API_REQUEST_CALL_URL } from '../utils/index';

export class AirLine {
	public airlineSeq:number;
	public name:string;
	public lineCd:string;
	public cntryCd:string;
	public iataCd:string;
	public icaoCd:string;
	public remark:string;
}

export class OceanLine {
    lineCd:string;
	lineNm:string;
    lineNm2:string;
	lineNmKr:string;
	alliance:string;
    cntryCd:string;
    cntryNm:string;
    corpId:number;
}

export class Line {
    lineCd:string;
    lineNm:string; 
    lineNm2:string;
    lineNmKr:string;
    alliance:string;
    cntryCd:string;
    cntryNm:string;
    corpId:number;
  }

@Injectable()
export class OceanLineService {
    @Output() lineListEe: EventEmitter<Array<OceanLine>> = new EventEmitter();
    public lineList: Array<OceanLine>;
    ingFlag = false;
    constructor(private http: Http, private apiService:ApiService) {
        this.getOceanLineList();
    }
    getOceanLineList(){
        if(!this.lineList){
            this.ingFlag = true;
            this.getOceanLines().subscribe((res) => {
                this.ingFlag = false;
                this.lineList = res.data;
                this.lineListEe.emit(this.lineList);
            });
        }else{
            this.lineListEe.emit(this.lineList);
        }
    }

    getOceanLines() {
        return this.apiService.get('oceanline');
    }
}


@Injectable()
export class AirLineService {
    @Output() lineListEe: EventEmitter<Array<AirLine>> = new EventEmitter();
    public lineList: Array<AirLine>;
    ingFlag = false;
    constructor(private http: Http, private apiService:ApiService) {
        this.getAirLineList();
    }

  getAirLineList(){
    if(!this.lineList || this.lineList.length < 1){
        this.ingFlag = true;
        this.apiService.get(REST_API_REQUEST_CALL_URL.GET_AIR_LINE_LIST_URL).subscribe(res => { 
            this.ingFlag = false;
            this.lineList = res.data;
            this.lineListEe.emit(this.lineList);
        });
    }else {
        this.lineListEe.emit(this.lineList);
    }
  }
}






// WEBPACK FOOTER //
// ./src/app/services/transportation.service.ts